import { React, useState, useEffect } from 'react'
import { Table, TableBody, Paper,Dialog } from "@material-ui/core";
import { globalGetService, globalDeleteService, globalExportService } from '../../../utils/globalApiServices';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { DownloadAllApi } from './apiServices';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { FleetSbListing, FleetSbTableHeader, AddEditFleetSB } from '../components';
import { downloadFileType, checkApiStatus } from '../../../utils';
import { EmptyCollection, PageLoader, DeletePopUp } from '../../../shared_elements';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { sbFilterOptions, sbSmbcFilterOptions } from './index';
import ShowAttachments from '../../../shared_elements/components/ShowAttachments';
import ImportFormat from '../../../shared_elements/components/ImportFormat';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
import { permissionCheckFnforCamo } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import Pagination from '../../../shared_elements/components/Pagination';
import { smbcInstance } from '../../../shared_elements/components';
import FleetCTA from '../../../shared_elements/components/FleetCTA';
import STabsLoader from '../../../shared_elements/components/skeleton_loader/STabsLoader';
function FleetMainSB({ match }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false)
    const [deletelist, setDeleteList] = useState({ modal: false, data: null })
    const [skeltonLoader, setSkeltonLoader] = useState(false)
    const [fleetSbListing, setFleetSbListing] = useState({ list: [], pagination: {} })
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [aaddEditFleetSB, setAddEditFleetSB] = useState({ modal: false, data: null, type: '' })
    const [importFile, setImportFile] = useState({ modal: false, data: null })
    const [filter, setFilter] = useState()
    const [applicability, setApplicability] = useState([])
    const [attchementsModal, setAttchementsModal] = useState({ modal: false, data: null, })

    useEffect(() => {
        getFleetSbListing({ per_page: 250, asset_type: 2 }, 'skeltonLoader')
        getApplicability()
        trackActivity('Fleet SB - Airworthiness Management', {
            event_type: 'Page Visited',
            page_title: 'Fleet SB'
        });
    }, [])

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getFleetSbListing({ ...sortQuery, per_page: 250, asset_type: 2 }, 'pageLoader');
    }


    const getFleetSbListing = (query, loaderType) => {
        loaderType === "skeltonLoader" ? setSkeltonLoader(true) : setLoading(true)
        globalGetService(`camo/fleet_sb/`, query)
            .then((response) => {
                loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false)
                if (checkApiStatus(response)) {
                    setFleetSbListing(response.data)
                    setFilter(query)
                }
            })
    }

    const deleteFleetSBList = () => {
        setLoading(true)
        globalDeleteService(`camo/fleet_sb/${deletelist?.data?.id}/`)
            .then((response) => {
                setLoading(false); setDeleteList({ modal: false }); getFleetSbListing({ per_page: 250, asset_type: 2 })
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Fleet SB Success - Airworthiness Management', {
                        event_type: 'Deleted',
                        page_title: 'Fleet SB',
                        deleted_id: deletelist?.data?.id,
                        success_msg: response?.data?.message
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Fleet SB Failed - Airworthiness Management', {
                        event_type: 'Deleted',
                        page_title: 'Fleet AD',
                        deleted_id: deletelist?.data?.id,
                        error_msg: response?.data?.message
                    })
                }

            })
    }
    const exportSBListing = (extension) => {
        const date = new Date()
        const todayDate = moment(String(date)).format("DD-MM-YYYY")
        setLoading(true);
        let queryParams = {}
        if (sortInfo?.sort === '' && sortInfo?.sort_by === '') {
            queryParams = Object.assign({}, filter);
        } else {
            queryParams = Object.assign({}, filter, sortInfo);
        }
        globalExportService(`/camo/fleet_sb/2/export/`, { download: extension, ...queryParams })
            .then(response => {
                setLoading(false);
                downloadFileType(response.data, `Fleet_SB_${todayDate}`, extension)
                enqueueSnackbar("Download Fleet SB List Successfully", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                trackActivity('Fleet SB Export - Airworthiness Management', {
                    event_type: 'Export',
                    page_title: 'Fleet SB',
                })
            });
    }

    const getApplicability = () => {
        globalGetService(`console/engine-types/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setApplicability(response?.data?.data?.engineTypes)
                }
            })
    }
    const deleteAttachements = (files, items, id) => {
        globalDeleteService(`camo/attachment/${id}/delete/?fleet=sb`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    getFleetSbListing({ per_page: 250, asset_type: 2 }, 'pageLoader')
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Fleet SB Attachment Deleted Success - Airworthiness Management', {
                        event_type: 'Deleted',
                        page_title: 'Fleet SB',
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                    trackActivity('Fleet SB Attachment Deleted Failed - Airworthiness Management', {
                        event_type: 'Deleted',
                        page_title: 'Fleet SB',
                    })
                }
            })

    }
    const openAttachment = (file) => {
        var decodedURL = decodeURIComponent(file);
        window.open(decodedURL, "_blank");
    };


    const filterObj = Object.assign({}, filter, delete filter?.per_page,delete filter?.page, delete filter?.sort, delete filter?.sort_by, delete filter?.asset_type)
    let filterOptions = Object.assign({}, smbcInstance ? sbSmbcFilterOptions : sbFilterOptions);
    filterOptions = {
        ...filterOptions,
        sb_applicability: {
            ...filterOptions.sb_applicability,
            options: applicability
        },
    }
    const tabsLoaderCount = window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 5 : 9;
    return (
        <section className='camo-fleet-module'>
            <DeploymentMessage />
            {skeltonLoader ? <STabsLoader count={tabsLoaderCount} /> :
                <FleetCTA
                    searchPlaceholder="Search ATA Chapter, SB Reference Number, SB Description, SB Type"
                    onSearch={(value) => getFleetSbListing({ search: value, asset_type: 2, per_page: 250 })}
                    permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" })}
                    addLabel="ADD SB"
                    onAddFn={() => setAddEditFleetSB({ modal: true, data: null, type: 'add' })}
                    onImportFn={() => setImportFile({ modal: true, data: null })}
                    exportMenu={{
                        exportReportFn: (file) => exportSBListing(file?.extension),
                        files: [{ title: 'PDF', extension: 'pdf' }, { title: 'EXCEL', extension: 'xlsx' }],
                        disabled: !fleetSbListing?.list?.length,
                    }}
                    filterObj={filterObj}
                    filterOptions={filterOptions}
                    getResponseBack={(applyFilter) => getFleetSbListing({ ...applyFilter, page: 1, per_page: 250, asset_type: 2 }, 'pageLoader')}
                />}
            {skeltonLoader ? <STableLoader count={tabsLoaderCount} size={11}/> :
                <Paper variant='outlined' square style={{ padding: '5px 10px', marginBottom: "5px" }}>
                    <div style={{ height: `${window.innerHeight - 220}px`, overflow: 'auto' }}>
                        <Table className='mui-table-format' stickyHeader={true}>
                            <FleetSbTableHeader
                                createSortHandler={(sort) => createSortHandler(sort)}
                                sortInfo={sortInfo}
                            />
                            <TableBody>
                                {fleetSbListing?.list?.map((item, index) =>
                                    <FleetSbListing
                                        item={item}
                                        key={index}
                                        toggleModalFn={() => setAddEditFleetSB({ modal: true, data: item, type: 'edit' })}
                                        toggleDelteModalFn={() => setDeleteList({ modal: true, data: item })}
                                        handleOpenAttachments={() => setAttchementsModal({ modal: true, data: item })}
                                    />
                                )}
                            </TableBody>
                        </Table>
                        {!fleetSbListing?.list?.length ? <EmptyCollection title="No Records Founds" /> : null}
                    </div>
                    <Pagination
                        pagination={fleetSbListing?.pagination}
                        onChangePage={(event, newPage) => getFleetSbListing({ ...filter, asset_type: 2, page: newPage + 1, per_page: fleetSbListing?.pagination?.per_page || 20 }, 'pageLoader')}
                        onChangeRowsPerPage={(event) => getFleetSbListing({ ...filter, page: 1, asset_type: 2, per_page: event.target.value }, 'pageLoader')}
                    />
                </Paper>
            }
            {aaddEditFleetSB.modal ?
                <AddEditFleetSB
                    fleetData={aaddEditFleetSB.data}
                    modeType={aaddEditFleetSB.type}
                    toggleModalFn={() => setAddEditFleetSB({ modal: false })}
                    getResponseBack={() => getFleetSbListing({ per_page: 250, asset_type: 2 })}
                /> : null
            }
            {deletelist.modal ?
                <DeletePopUp
                    title='Delete Fleet SB'
                    deleteRecordFn={() => deleteFleetSBList()}
                    modal={() => setDeleteList({ modal: true })}
                    content='Do you really want to delete this record?'
                    toggleModalFn={() => setDeleteList({ modal: false })}
                /> : null

            }
            {importFile.modal ?
                <ImportFormat
                    title="Import Fleet SB"
                    moduleType='fleet_sb'
                    fleet={true}
                    moduleName="SampleFile Fleet SB"
                    getResponseBack={() => getFleetSbListing({ per_page: 250, asset_type: 2 })}
                    toggleModalFn={() => setImportFile({ modal: false })}
                /> : null
            }
            {
                attchementsModal.modal ?
                    <Dialog
                        open={true}
                        onClose={() => setAttchementsModal({ modal: false, data: null })}
                        id="htDialog"
                    >
                        <ShowAttachments
                            handleClose={() => setAttchementsModal({ modal: false, data: null })}
                            handleShowAttachments={fleetSbListing?.list.filter(item => item?.id === attchementsModal?.data?.id).map(item => item?.attachments)[0]}
                            openAttachment={openAttachment}
                            files={{ title: "SB", extension: "zip", key: "" }}
                            downloadAllApi={() => DownloadAllApi(attchementsModal.data, 'SB')}
                            item={attchementsModal.data}
                            removeAttachment={deleteAttachements}
                        />
                    </Dialog>
                    :
                    null
            }
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}

export default withRouter(FleetMainSB)